import React from 'react';
import {Typography, Button, Grid} from 'antd';
import {
  UserOutlined,
  EditOutlined,
  PlusOutlined,
  MinusCircleOutlined
} from '@ant-design/icons';
import PatientSelect from './PatientSelect';
import { useTranslation } from 'react-i18next';

const { useBreakpoint } = Grid;
const { Text } = Typography;

const PatientSelectorPanel = ({
                                selectedPatient,
                                onSelect,
                                onAddPatient,
                                onEditPatient,
                                onUnlinkPatient,
                                fromLinkPatientModal = false,
                                fromPatientDetails = false
                              }) => {
  const screens = useBreakpoint();
  const { t } = useTranslation();

  const renderSelector = () => (
    <div style={{ display: 'flex', flexWrap: 'nowrap', gap: 8, marginTop: 8 }}>
      <div style={{ flex: '1 1 auto', minWidth: 0, textAlign: 'left' }}>
        <PatientSelect
          data-testid="patient-selector"
          selectedPatient={selectedPatient}
          onSelect={onSelect}
          onAddNewPatient={onAddPatient}
          placeholder={
            fromLinkPatientModal
              ? t('patient_selector_panel.search_placeholder')
              : t('patient_selector_panel.select_placeholder')
          }
        />
      </div>
      <div style={{ flex: '0 0 auto' }}>
        <Button icon={<PlusOutlined />} onClick={onAddPatient}>
          {screens.xs
            ? t('patient_selector_panel.new_patient_short')
            : t('patient_selector_panel.new_patient')}
        </Button>
      </div>
    </div>
  );

  const renderSummary = () => (
    <div style={{ display: 'flex', alignItems: 'center', marginTop: 8 }}>
      <Text strong style={{ marginLeft: 18, fontSize: 15 }}>
        {selectedPatient.getFullName()}
      </Text>
      <div style={{marginLeft: 'auto'}}>
        <Button
          type="link"
          size="small"
          icon={<EditOutlined/>}
          onClick={onEditPatient}
          style={{color: '#008B8B'}}
        >
          {t('patient_selector_panel.edit')}
        </Button>
        {/* removing unlink button for now, since having it would complicate file attachments */}
        {/* {!fromPatientDetails && (<Button
          type="link"
          size="small"
          icon={<MinusCircleOutlined/>}
          onClick={onUnlinkPatient}
          style={{color: '#008B8B'}}
        >
          {t('patient_selector_panel.unlink')}
        </Button>
        )} */}
      </div>
    </div>
  );

  return (
    <div data-testid="patient-selector-panel">
      {!fromLinkPatientModal && (
        <div style={{display: 'flex', alignItems: 'center', marginBottom: 4}}>
          <UserOutlined style={{marginRight: 8}}/>
          <Text>{t('patient_selector_panel.title')}</Text>
        </div>
      )}
      {selectedPatient && !fromLinkPatientModal ? renderSummary() : renderSelector()}
    </div>
  );
};

export default PatientSelectorPanel;